import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { Link } from 'react-router-dom';   // ✅ 追加
import styles from './EventCard.module.css';

const EventCard = ({
  event,
  variant = "grid",
  userId = null,
  profileRole = null,
  showCheckinButton = false,
  showMemoriesButton = false
}) => {
  const eventPathId = event?.slug || event?.id;
  const flyers = event.flyers || [];
  const [currentIndex, setCurrentIndex] = useState(0);

  const isCarousel = variant === "carousel";

  const handlers = useSwipeable({
    onSwipedLeft: () =>
      flyers.length > 0 &&
      setCurrentIndex((prev) => (prev + 1) % flyers.length),
    onSwipedRight: () =>
      flyers.length > 0 &&
      setCurrentIndex((prev) => (prev - 1 + flyers.length) % flyers.length),
    trackMouse: true,
  });

  const dateText = event?.date ? String(event.date).slice(0, 10) : "";
  const venueText = event?.venue ? `@ ${event.venue}` : "";

  // ✅ carousel（カード全体Link）
  if (isCarousel) {
    return (
      <Link
        className={`${styles.cardLink} ${styles.cardCarouselLink}`}
        to={`/events/${eventPathId}`}
      >
        <div className={`${styles.card} ${styles.cardCarousel}`}>
          <div className={styles.cardTitle}>{event.name}</div>

          {flyers.length > 0 ? (
            <div className={`${styles.slider} ${styles.sliderTop}`} {...handlers}>
              <img
                src={flyers[currentIndex].url}
                alt={`${event.name} flyer`}
                loading="lazy"
                className={styles.flyer}
              />
              {flyers.length > 1 && (
                <div className={styles.indicator}>
                  {flyers.map((flyer, i) => (
                    <span
                      key={flyer.id ?? i}
                      className={i === currentIndex ? styles.dotActive : styles.dot}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setCurrentIndex(i);
                      }}
                    />
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div className={styles.noImage}>No Image</div>
          )}
          <p className={styles.meta}>{dateText}</p>
          <p className={`${styles.meta} ${styles.venueText}`}>{venueText}</p>
        </div>
      </Link>
    );
  }

  // ✅ grid（ボタン型Link）
  return (
    <div className={styles.card}>
      <div className={styles.cardTitle}>{event.name}</div>

      {flyers.length > 0 ? (
        <div className={styles.slider} {...handlers}>
          <img
            src={flyers[currentIndex].url}
            alt={`${event.name} flyer`}
            loading="lazy"
            className={styles.flyer}
          />
          {flyers.length > 1 && (
            <div className={styles.indicator}>
              {flyers.map((flyer, i) => (
                <span
                  key={flyer.id ?? i}
                  className={i === currentIndex ? styles.dotActive : styles.dot}
                  onClick={() => setCurrentIndex(i)}
                />
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className={styles.noImage}>No Image</div>
      )}

      <p>{dateText}</p>
      <p className={styles.venueText}>@ {event.venue}</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Link to={`/events/${eventPathId}`}>
          <button className={styles.button}>詳細を見る</button>
        </Link>

        {showCheckinButton && (
          <Link to={`/events/${eventPathId}/checkin`}>
            <button
              className={styles.button}
              style={{ background: '#34d399' }}
            >
              チケットを表示する
            </button>
          </Link>
        )}

        {showMemoriesButton && (
          <Link to={`/events/${eventPathId}/memories`}>
            <button
              className={styles.button}
              style={{ background: '#60a5fa' }}
            >
              思い出投稿
            </button>
          </Link>
        )}

      </div>
    </div>
  );
};

export default EventCard;
